
export default {
	name: "CalendarViewHeader",
	props: {
		headerProps: {
			type: Object,
			required: true,
		},
		previousYearLabel: { type: String, default: "<<" },
		previousPeriodLabel: { type: String, default: "<" },
		nextPeriodLabel: { type: String, default: ">" },
		nextYearLabel: { type: String, default: ">>" },
	},
	methods: {
		onInput(d) {
			this.$emit("input", d)
		},
	},
}
